import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import styled from 'styled-components';
import Snackbar from '@material-ui/core/Snackbar';
import { SnackbarContent } from "../../styled-components/shared";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel'; 
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from "react-i18next";

import { APModel, APService } from "../../Services/AccessPointService";
import Checkbox from '@material-ui/core/Checkbox';

import SiteFilter from "../../pages/Dashboard/SitesDashboard/Components/SiteFilter";

import { StyledField, StyledTextField, LabelText, ErrorLine, HeadDes, BodyContent } from "./Styles";

import { Formcontainer, PopupContainer, FooterContainer, PopupHeader, CheckBoxRow, TransBtn, BlueBtn } from "./Styles";

 
class APProps {

    //Modal Ref
    modalRef;

    //Indicates whether user is manager
    isManager;

    //The site assigned to the manager in case if he is manager
    assignedSite;

    //TenantId
    tenantId;

    //Callback for access point updated
    onAccessPointUpdated;

    //EditType ->Site indicates that it is site update
    //Type others indicate it is for other fields
    editType;
}

export function EditAccessPointModal(args) {


    var props = new APProps();
    props = args;

    const dialogRef = props.modalRef;

    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const errors = useRef([]);
    const [hasErrors, setHasErrors] = useState(false);

    const service = new APService();

    
    var defaultValue = {
        macAddress: "",
        friendlyName: props.selectedItems.length,
        assetName: "",
    };



    // 
    // if(props.selectedItems != null && props.selectedItems.length > 0){

    //     defaultValue = {
    //         macAddress: props.selectedItems[0].apMacAddress,
    //         friendlyName: props.selectedItems[0].apFriendlyName,
    //         assetName: props.selectedItems[0].apAssetName
    //     }
    // }
    const [model, setModel] = useState(defaultValue);

    const isManager = props.isManager;
    //Default site assigned if manager
    const assignedSite = props.assignedSite;

    const tenantId = props.tenantId;

    const onAccessPointUpdated = props.onAccessPointUpdated;
    const [applyToAllSites, setApplyToAllSites] = useState(false);

    useEffect(() => {
        clearForm();
    }, [""]);


    useEffect(() => {

    
        if (args.selectedItems.length > 0) {

            setModel({
                macAddress: args.selectedItems[0].apMacAddress,
                friendlyName: args.selectedItems[0].apFriendlyName,
                //siteName: args.selectedItems[0].siteName,
                assetName: args.selectedItems[0].apAssetName,
            });
        }

        
        setApplyToAllSites(false);
    }, [args.id]);


    function clearForm() {

        setModel({
            macAddress: "",
            friendlyName: "",
            siteName: "",
            assetName: ""
        });

        setApplyToAllSites(false);
        //Clear the errors
        errors.current = [];
    }

    function validateRequired(value, fieldName, validationMsgKey) {

        if (value == null || value.trim() == "") {
            //Add the required error against the field name
            errors.current.push({ "fieldName": fieldName, "errorMessage": t(validationMsgKey) });
        }
    }

    function validateFieldLength(value, fieldName, maxLength, validationMsgKey) {

        if (value == null || value.trim() == "" ) {
            //NULL value. No need for futher validation
            return;
        }
 
        if (value.length > maxLength) {
            //Add the MAX length Error  against the field name
            errors.current.push({ "fieldName": fieldName, "errorMessage": t(validationMsgKey) });
            //errors[fieldName] = "Please provide a value with length less than " + maxLength;
        }
    }

    function validateAccessPoint() {
        errors.current = [];

        const MAX_CHARS = 32;
        const MAX_CHARS_MSG_KEY = "validation.rules.sso.rule45";
        const REQUIRED_TXT_MSG_KEY = "validation.rules.Mo_Dash.RequiredTxtMessage";
        const REQUIRED_DROPDOWN_MSG_KEY = "validation.rules.Mo_Dash.RequiredDropdownMessage";

        //Validate each field
        //All the fields have the same MAX length. So use the same ERR MSG & MAX CHARS
        //validateRequired(model.macAddress, "macAddress", REQUIRED_MSG_KEY);
        //validateFieldLength(model.macAddress, "macAddress", MAX_CHARS, VALIDATION_MSG_KEY);

        if (isSiteUpdate) {
            //Site Update. Only validate site
            validateRequired(model.siteName, "siteName", REQUIRED_DROPDOWN_MSG_KEY);
        }
        else {
            validateRequired(model.friendlyName, "friendlyName", REQUIRED_TXT_MSG_KEY);
            validateFieldLength(model.friendlyName, "friendlyName", MAX_CHARS, MAX_CHARS_MSG_KEY);

            //validateRequired(model.modelNumber, "modelNumber", "maxCharsCountMsg");
            //Device friendly name is optional
            validateFieldLength(model.assetName, "assetName", MAX_CHARS, MAX_CHARS_MSG_KEY);
        }
        //To update state for rerender 
        setHasErrors(!hasErrors);
    }

    function getErrorMessage(field) {

        const error = errors.current.find((error) => error.fieldName == field);
        return error ? error.errorMessage : null;
    }



    function handleCancel() {

        //Clear the form and close it
        clearForm();
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    function renderSiteUpdateFields() {
        return (<div>
            <SiteFilter siteName={model.siteName} onSiteSelected={(value) => {
                setModel({ ...model, siteName: value });
            }} />
            <ErrorLine style={{ display: getErrorMessage("siteName") != null ? 'block' : 'none' }}>
                {getErrorMessage("siteName")}
            </ErrorLine>
        </div>);

    }


    function renderUpdateFields() {
        return (<div>

            <Formcontainer>
                <LabelText>{t('accessPoint.assetName')}</LabelText>
                <StyledTextField
                    id='outlined-basic'
                    variant="outlined"
                    error={getErrorMessage("assetName")}
                    onChange={(e) => setModel({ ...model, assetName: e.target.value })}
                    placeholder={t('Mo_Dash.placeholders.enter_assetName')}
                    value={model.assetName}

                />
                <ErrorLine style={{ display: getErrorMessage("assetName") != null ? 'block' : 'none' }}>
                    {getErrorMessage("assetName")}
                </ErrorLine>
            </Formcontainer>

            <Formcontainer>
                <LabelText>{t('accessPoint.friendlyName')}</LabelText>
                <StyledTextField
                    id='outlined-basic'
                    variant="outlined"
                    error={getErrorMessage("friendlyName")}
                    onChange={(e) => setModel({ ...model, friendlyName: e.target.value })}
                    placeholder={t('Mo_Dash.placeholders.enter_friendlyName')}
                    value={model.friendlyName}

                />
                <ErrorLine style={{ display: getErrorMessage("friendlyName") != null ? 'block' : 'none' }}>
                    {getErrorMessage("friendlyName")}
                </ErrorLine>
            </Formcontainer></div>);

    }

    const isSiteUpdate = props.editType == "SITE" ? true : false;

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }


    async function handleConfirmClick() {
 //details update
        validateAccessPoint();

        if (errors.current.length == 0) {
            
            setIsLoading(true);
            //No errors..
            if (isSiteUpdate) {
                
                //Updte the site only
                if (applyToAllSites) {
                    //All sites needs to be updated
                    await service.updateSiteForAllAccessPoints(tenantId, props.query, model.siteName);
                }
                else {
                    //Update selected sites
                    await service.updateSite(tenantId, props.selectedItems, model.siteName);
                }
            }
            else {

                //Field uupdate
                //Add to DB
                //Update the fields
                //props.selectedImtes will have the array with 1 item
                //Update access points accepts array. For now EDIT is for one item
                //So just wrap the item to Array
                var items = [
                    {
                        friendlyName: model.friendlyName,
                        assetName: model.assetName,
                        macAddress: props.selectedItems[0].apMacAddress
                    }
                ];
                await service.updateAccesspoint(tenantId, items);

            }
            setIsLoading(false);
            //Clear the forms for next show
            clearForm();

            //close the dialog
            dialogRef.current.toggleDialog();
            //call success callback 
            props.onAccessPointUpdated(applyToAllSites);
        }

    }

    function clearForm() {

        setModel({
            macAddress: "",
            friendlyName: "",
            siteName: "",
            assetName: ""
        });

        setApplyToAllSites(false);
        //Clear the errors
        errors.current = [];
    }

  
    return (
        <div>
            <Dialog
                ref={dialogRef}
                key='dialog255'
                width={'520px'}
              
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px' }}>

                <PopupContainer>
                    <PopupHeader>{isSiteUpdate ? t('accessPoint.updateSiteTitle') :
                        t('accessPoint.updateAPTitle')}</PopupHeader>
                    <HeadDes>{t('manual')}</HeadDes>
                    <BodyContent>
                        <form noValidate
                            style={{ pointerEvents: isLoading ? 'none' : '' }}>

                            { /* Render corresponding fields base on siteupdte/other update */}
                            {isSiteUpdate ? renderSiteUpdateFields() : renderUpdateFields()}

                            { /* Render the All checkbox only when user selects all items and only
                        for Site update */ }
                            {isSiteUpdate && props.allItemsSelected
                                && <CheckBoxRow>
                                    <Checkbox
                                        checked={applyToAllSites}
                                        color="primary"
                                        onClick={e => { setApplyToAllSites(!applyToAllSites) }}
                                        name="deviceRow" />
                                    <p>{t("updateAllRecordsConfirmMsg")}</p>
                                </CheckBoxRow>}
                        </form>
                    </BodyContent>

                    <FooterContainer style={{ pointerEvents: isLoading ? 'none' : '' }}>
                        <TransBtn onClick={() => { handleCancel() }}>{t('cancel')}</TransBtn>
                        <BlueBtn onClick={handleConfirmClick}>{isLoading ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                    </FooterContainer>
                </PopupContainer>

            </Dialog>
        </div>
    )
} 